import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedCurrency from '@s/FormattedCurrency';
import Translation from '@s/Translation';
import { connect } from 'react-redux';

class OrderTotalCharges extends Component {
    render() {

        return(
            <div className="items-total">
                <div className="items-total__label" role="heading" aria-level="2">
                    <Translation>{'checkout__order_total'}</Translation>
                </div>
                <div className="items-total__amount">
                    <FormattedCurrency>
                        {(this.props.chargeDeliveryFee && this.props.deliveryFee) ? this.props.total - this.props.deliveryFee : this.props.total}
                    </FormattedCurrency></div>
            </div>
        )
    }
}

OrderTotalCharges.propTypes = {
    total: PropTypes.number.isRequired
}

const mapStateToProps = state => {
    return {
        deliveryFee: state.fees?.deliveryFee?.amount,
        chargeDeliveryFee: state.reservation?.noDeliveryFee,
    }
}

export default connect(mapStateToProps)(OrderTotalCharges);